import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initFacebookPixel } from './lib/fpixel';
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-11" />);
}
// Defer non-critical analytics so it never blocks first paint / LCP.
const startPixel = () => initFacebookPixel();
if ('requestIdleCallback' in window) {
  ;
  (window as any).requestIdleCallback(startPixel, {
    timeout: 4000
  });
} else {
  setTimeout(startPixel, 2500);
}